import { render, staticRenderFns } from "./EventAppleNoticeModal.vue?vue&type=template&id=6bf1b02b&scoped=true"
import script from "./EventAppleNoticeModal.vue?vue&type=script&lang=js"
export * from "./EventAppleNoticeModal.vue?vue&type=script&lang=js"
import style0 from "./EventAppleNoticeModal.vue?vue&type=style&index=0&id=6bf1b02b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf1b02b",
  null
  
)

export default component.exports